// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"SimilarVehiclesModal_modalTitle__tKj2h","modalDialog":"SimilarVehiclesModal_modalDialog__iS_Tw","modalContent":"SimilarVehiclesModal_modalContent__tcWug"};